<template>
  <div class="schedule">
    <div
      class="schedule-list"
      v-if="
        timeTable.length > 0 && timeTable[0].time !== 'event' && !changeTimes
      "
    >
      <div
        class="schedule-time"
        v-for="(time, index) in timeTable"
        :key="index"
      >
        <span>{{ time.time }}</span>
        <div class="progress-bar">
          <div
            class="fill-bar"
            :style="
              'width:' +
              (time.allocation.reduce((total, obj) => total + obj.total, 0) /
                50) *
                100 +
              '%'
            "
          >
            <a
              @click="
                openInfoModal = true;
                currentIndex = index;
              "
              >{{
                Math.round(
                  (time.allocation.reduce(
                    (total, obj) => total + obj.total,
                    0
                  ) /
                    50) *
                    100
                ) +
                "%" +
                (time.allocation.reduce((total, obj) => total + obj.total, 0) /
                  50 >
                0.19
                  ? " COMPLETO"
                  : "")
              }}</a
            >
          </div>
        </div>
        <div class="languages">
          <img
            src="../../../assets/images/pt.png"
            :class="{
              active: [
                ...new Set(time.allocation.flatMap((obj) => obj?.languages)),
              ].includes('PT'),
            }"
          />
          <img
            src="../../../assets/images/en.png"
            :class="{
              active: [
                ...new Set(time.allocation.flatMap((obj) => obj?.languages)),
              ].includes('EN'),
            }"
          />
          <img
            src="../../../assets/images/es.png"
            :class="{
              active: [
                ...new Set(time.allocation.flatMap((obj) => obj?.languages)),
              ].includes('ES'),
            }"
          />
          <img
            src="../../../assets/images/fr.png"
            :class="{
              active: [
                ...new Set(time.allocation.flatMap((obj) => obj?.languages)),
              ].includes('FR'),
            }"
          />
        </div>
        <button
          v-if="
            time.allocation.reduce((total, obj) => total + obj.total, 0) < 50
          "
          @click="addSchedule(index)"
        >
          +
        </button>
        <button class="full" v-else>✓</button>
      </div>
    </div>
    <div v-else class="time-select">
      <div class="time-block" v-for="(block, index) in times" :key="index">
        <Switch
          v-for="(time, j) in block"
          :enabled="selectedTimes.includes(time)"
          :emit-on-mount="false"
          :showLabel="true"
          :label="time"
          :disabled="
            timeTable.find((t) => t.time === time)?.allocation.lenfgth > 0
          "
          @input="toggleTime(time)"
          :key="j"
        />
      </div>
    </div>
    <div
      v-if="
        timeTable.length === 0 || timeTable[0].time === 'event' || changeTimes
      "
      class="buttons"
    >
      <fyi-button :label="'Confirmar'" @click="setTimes"></fyi-button>
      <fyi-button
        v-if="timeTable[0]?.time !== 'event'"
        :label="'Declarar Encerrado'"
        @click="setClosed"
      ></fyi-button>
      <fyi-button
        v-else
        :label="'Encerrado de momento'"
        class="closed"
      ></fyi-button>
    </div>
    <div v-else class="buttons">
      <fyi-button
        :label="'Alterar Horários'"
        @click="changeTimes = true"
      ></fyi-button>
      <fyi-button :label="'Declarar Encerrado'" @click="setClosed"></fyi-button>
    </div>
  </div>
  <teleport to="body">
    <div class="bg" v-if="openScheduleModal">
      <div class="schedule-modal">
        <div class="schedule-modal__header">
          Adicionar pessoas às {{ timeTable[currentIndex].time }}
        </div>
        <div class="schedule-modal__body">
          <div class="pad">
            <button @click="addTotal('1')">1</button>
            <button @click="addTotal('2')">2</button>
            <button @click="addTotal('3')">3</button>
            <button @click="addTotal('4')">4</button>
            <button @click="addTotal('5')">5</button>
            <button @click="addTotal('6')">6</button>
            <button @click="addTotal('7')">7</button>
            <button @click="addTotal('8')">8</button>
            <button @click="addTotal('9')">9</button>
            <button></button>
            <button @click="addTotal('0')">0</button>
            <button @click="deleteTotal"><i class="i-eraser" /></button>
          </div>
          <input
            class="pad-number"
            type="text"
            :value="allocation.total"
            :disabled="true"
          />
          <span class="pad-note"
            >(só pode adicionar no máximo
            {{
              50 -
              timeTable[currentIndex].allocation.reduce(
                (total, obj) => total + obj.total,
                0
              )
            }}
            pessoas )</span
          >
          <span class="languages-title">Línguas</span>
          <div class="languages">
            <img
              src="../../../assets/images/pt.png"
              :class="{ active: allocation.languages.includes('PT') }"
              @click="addLang('PT')"
            />
            <img
              src="../../../assets/images/en.png"
              :class="{ active: allocation.languages.includes('EN') }"
              @click="addLang('EN')"
            />
            <img
              src="../../../assets/images/es.png"
              :class="{ active: allocation.languages.includes('ES') }"
              @click="addLang('ES')"
            />
            <img
              src="../../../assets/images/fr.png"
              :class="{ active: allocation.languages.includes('FR') }"
              @click="addLang('FR')"
            />
          </div>
          <span class="observations">Observações </span>
          <input ref="observations" type="text" />
        </div>
        <div class="schedule-modal__footer">
          <fyi-button
            :disabled="
              allocation.languages.length === 0 || allocation.total === ''
            "
            :label="'Confirmar'"
            @click="addAllocation"
          ></fyi-button>
          <fyi-button
            :label="'Fechar'"
            @click="openScheduleModal = false"
          ></fyi-button>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <div class="bg" v-if="openInfoModal">
      <div class="schedule-info">
        <div class="schedule-modal__header">
          Informação - {{ timeTable[currentIndex].time }}
          <i @click="openInfoModal = false" class="i-close"></i>
        </div>
        <div class="schedule-modal__body">
          <div
            v-for="(allocation, index) in timeTable[currentIndex].allocation"
            :key="index"
          >
            <span>{{ allocation.total }} pessoas</span>
            <div class="languages">
              <img
                v-if="allocation.languages.includes('PT')"
                src="../../../assets/images/pt.png"
                class="active"
              />
              <img
                v-if="allocation.languages.includes('EN')"
                src="../../../assets/images/en.png"
                class="active"
              />
              <img
                v-if="allocation.languages.includes('ES')"
                src="../../../assets/images/es.png"
                class="active"
              />
              <img
                v-if="allocation.languages.includes('FR')"
                src="../../../assets/images/fr.png"
                class="active"
              />
            </div>
            <p>
              {{
                allocation.observations && allocation.observations !== ""
                  ? "Obs: " + allocation.observations
                  : ""
              }}
            </p>
            <i @click="removeAllocation(index)" class="i-close"></i>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <div class="bg" v-if="openReconnectModal">
      <div class="reconnect-modal">
        <h4>Atualização em tempo real indisponível</h4>
        <p>A tentar reconectar...</p>
        <fyi-loading :size="'small'" />
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <Toast v-if="toast_show" :type="toast_type" :message="toast_message" />
  </teleport>
</template>

<script>
import { mapActions } from "vuex";
import { io } from "socket.io-client";

export default {
  name: "Schedule",
  data() {
    return {
      times: [
        ["09:00", "09:15", "09:20", "09:30", "09:40", "09:45"],
        ["10:00", "10:15", "10:20", "10:30", "10:40", "10:45"],
        ["11:00", "11:15", "11:20", "11:30", "11:40", "11:45"],
        ["12:00", "12:15", "12:20", "12:30", "12:40", "12:45"],
        ["13:00", "13:15", "13:20", "13:30", "13:40", "13:45"],
        ["14:00", "14:15", "14:20", "14:30", "14:40", "14:45"],
        ["15:00", "15:15", "15:20", "15:30", "15:40", "15:45"],
        ["16:00", "16:15", "16:20", "16:30", "16:40", "16:45"],
        ["17:00", "17:15", "17:20", "17:30", "17:40", "17:45"],
        ["18:00", "18:15", "18:20", "18:30", "18:40", "18:45"],
      ],
      selectedTimes: [],
      timeTable: [],
      openScheduleModal: false,
      allocation: {
        total: "",
        languages: [],
      },
      openInfoModal: false,
      currentIndex: 0,
      horario: [],
      changeTimes: false,
      socket: null,
      toast_show: false,
      toast_type: "info",
      toast_message: "Limite de slot alterado.",
      openReconnectModal: false,
    };
  },
  async beforeMount() {
    const response = await this.getGestaoHorarios();
    this.timeTable = response.data ?? [];
    this.timeTable.forEach((t) => {
      if (t.time !== "event") {
        this.selectedTimes.push(t.time);
      }
    });
    this.$parent.$parent.view = this.$t("schedule");
    this.$parent.$parent.transition = false;
  },
  beforeUnmount() {
    this.socket.close();
  },
  mounted() {
    //SOCKET
    var configs = {
      node_address: "https://node.fyi.pt:8010",
    };
    this.socket = io(configs.node_address, {
      secure: true,
      query: "pb=new_bo",
      reconnection: true,
      reconnectionDelay: 1000,
      timeout: 20000, // Connection timeout (in ms)
      transports: ["websocket"], // Use WebSocket transport
    });

    this.socket.connect();

    this.socket.on("hora", (timeTable) => {
      this.timeTable = timeTable;
      if (this.openScheduleModal) {
        this.allocation.total = "";
        this.toast_type = "info";
        this.toast_message = "Limite de slot alterado.";
        this.toast_show = true;
        setTimeout(() => {
          this.toast_show = false;
        }, 5000);
      }
    });

    this.socket.on("connect", async () => {
      const response = await this.getGestaoHorarios();
      this.timeTable = response.data ?? [];
      this.openReconnectModal = false;

      console.log("connected");
    });

    this.socket.on("disconnect", () => {
      this.openReconnectModal = true;
      console.log("disconnected");
    });
  },
  methods: {
    ...mapActions(["getGestaoHorarios", "saveGestaoHorarios"]),
    addTotal(value) {
      if (this.allocation.total === "" && value === "0") return;

      this.allocation.total += value;

      const currentAllocation = this.timeTable[
        this.currentIndex
      ].allocation.reduce((total, obj) => total + obj.total, 0);

      if (parseInt(this.allocation.total) + currentAllocation > 50) {
        this.allocation.total = (50 - parseInt(currentAllocation)).toString();
      }
    },
    deleteTotal() {
      this.allocation.total = "";
    },
    addLang(lang) {
      if (this.allocation.languages.includes(lang)) {
        this.allocation.languages.splice(
          this.allocation.languages.indexOf(lang),
          1
        );
      } else {
        this.allocation.languages.push(lang);
      }
    },
    async addAllocation() {
      if (
        this.allocation.languages.length === 0 ||
        this.allocation.total === "" ||
        this.allocation.total === 0
      )
        return;

      this.allocation.total = parseInt(this.allocation.total);
      this.allocation.observations = this.$refs.observations.value;
      this.timeTable[this.currentIndex].allocation.push(this.allocation);

      this.allocation = {
        total: "",
        languages: [],
      };
      this.openScheduleModal = false;
      try {
        await this.saveGestaoHorarios(this.timeTable);
        this.socket.emit("hourUpdated", this.timeTable);
      } catch (err) {
        this.toast_type = "error";
        this.toast_message =
          "Não foi possível adicionar alocação. Tente novamente";
        this.toast_show = true;
        this.timeTable[this.currentIndex].allocation.pop();
        setTimeout(() => {
          this.toast_show = false;
        }, 5000);
        console.log(err);
      }
    },
    removeAllocation(index) {
      this.timeTable[this.currentIndex].allocation.splice(index, 1);
      this.saveGestaoHorarios(this.timeTable);
      this.socket.emit("hourUpdated", this.timeTable);
    },
    toggleTime(time) {
      if (this.selectedTimes.includes(time)) {
        this.selectedTimes.splice(this.selectedTimes.indexOf(time), 1);
      } else {
        this.selectedTimes.push(time);
      }
    },
    setTimes() {
      this.changeTimes = false;
      let final = [];
      this.selectedTimes.forEach((t) => {
        final.push({
          time: t,
          allocation: this.timeTable.find((tt) => tt.time === t)
            ? this.timeTable.find((tt) => tt.time === t).allocation
            : [],
        });
      });

      this.timeTable = final.sort((a, b) => {
        return parseInt(a.time.replace(":", "")) >
          parseInt(b.time.replace(":", ""))
          ? 1
          : -1;
      });

      this.saveGestaoHorarios(this.timeTable);
      this.socket.emit("hourUpdated", this.timeTable);
    },
    setClosed() {
      this.timeTable = [{ time: "event" }];
      this.saveGestaoHorarios([{ time: "event" }]);
      this.socket.emit("hourUpdated", this.timeTable);
    },
    addSchedule(index) {
      this.openScheduleModal = true;
      this.currentIndex = index;

      const currentAllocationSchedule =
        this.timeTable[this.currentIndex].allocation;
      this.allocation.languages = [
        ...new Set(currentAllocationSchedule.flatMap((item) => item.languages)),
      ];
    },
  },
};
</script>

<style lang="scss">
@import "../../../styles/pages/schedule.scss";
</style>
